interface GetCreditCounselingProviderItemsOptions {
  items: string[];
  variant: string;
  partnerDisplayName?: string;
  whiteLabelEnabled?: boolean;
}

const CREDIT_ORG =
  'Springboard Nonprofit Consumer Credit Management, Inc. dba Credit.org';
const CC_WHITELABEL_VARIANT = 'cc-singleform-end';
const CC_PARTNER_NAME = 'consolidated credit';

export const getCreditCounselingProviderItems = ({
  items,
  variant,
  partnerDisplayName = '',
  whiteLabelEnabled = false,
}: GetCreditCounselingProviderItemsOptions): string[] => {
  const isCcWhitelabel =
    variant === CC_WHITELABEL_VARIANT ||
    (whiteLabelEnabled &&
      partnerDisplayName.toLowerCase().includes(CC_PARTNER_NAME));

  return isCcWhitelabel ? items.filter((item) => item !== CREDIT_ORG) : items;
};
